import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
declare global {
  interface Window {
    electronAPI: {
      send: (chanell: string, data: any) => void;
    };
  }
}
@Injectable({
  providedIn: 'root'
}) export class PosIpcService {

  // tslint:disable-next-line:no-shadowed-variable
  constructor() {

  }

  onBtnClick(): void {
    window.electronAPI.send('btn-click', 'Button clicked from Angular');
  }
  activarTecladoVirtual() {
    window.electronAPI.send('activate-keyboard', 'Activate POS KeyBoard');
  }
  send(channel: string, data: any) {
    window.electronAPI.send(channel, data);
  }
}
